module.exports = __webpack_public_path__ + "img/Icon_info_pink.1055580a.svg";